import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

export interface RedirectPageProps {
  fallbackPath: string;
}

export const RedirectPage = ({ fallbackPath }: RedirectPageProps) => {
  const [shouldFallback, setShouldFallback] = useState(false);

  useEffect(() => {
    broadcastResponseToMainFrame().catch(() => {
      setShouldFallback(true);
    });
  }, []);

  if (shouldFallback) return <Navigate to={fallbackPath} replace />;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100%',
      }}
      aria-label="Loading"
    />
  );
};
